import { useEffect } from 'react';
import { FallbackProps } from 'react-error-boundary';

import { useRebrand } from '@growtherapy/sprout-ui';

import { logger } from '../datadog/logger';
import { DescriptiveError } from './DescriptiveError';
import { ErrorPageContent } from './ErrorPage';
import type { ErrorPageProps } from './ErrorPage';

/**
 * React error boundary fallback component for the app.
 *
 * Can display the user-friendly text fields of thrown
 * {@link DescriptiveError}s.
 */
export function ErrorPage({
  error,
  title: givenTitle,
  subtitle: givenSubtitle,
  ...props
}: ErrorPageProps & Partial<FallbackProps>) {
  const isRebrand = useRebrand();

  useEffect(
    function logError() {
      logger.error('The page crashed after encountering an unexpected error; displaying fallback', {}, error);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  const textFieldsFromError = error instanceof DescriptiveError ? { title: error.title, subtitle: error.subtitle } : {};
  const textFields = {
    title: givenTitle || textFieldsFromError.title,
    subtitle: givenSubtitle || textFieldsFromError.subtitle,
  };

  return <ErrorPageContent {...props} {...textFields} isRebrand={isRebrand} />;
}
